var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('loader',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?_c('ViewEmail',{attrs:{"data":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }